import React from "react";
import CheckboxGroup from "../../CheckboxGroup";
import { Box } from "@mui/material";

const Soil = ({ value, onChange }) => {
  const options = [
    "sandy",
    "loam",
    "clay",
    "adaptable",
    "well draining",
    "water retentive",
  ];

  const handleSunlightChange = (selectedOptions) => {
    onChange(selectedOptions);
  };

  return (
    <Box>
      <CheckboxGroup
        title={"Soil"}
        options={options}
        selectedOptions={value}
        onChange={handleSunlightChange}
      />
    </Box>
  );
};
export default Soil;
